import './_common.js';
import '../css/search-results.scss';
import { getSearchAutocompletion } from './_search-autocompletion.js';
import './ui-part/iframe-calendar.js';
import './ui-part/user-template.js';

function setupTopicSearchAutocompletion()
{
    let input = document.querySelector('.search-results-form-topic .enhanced-input-control');
    let hiddenInput = document.querySelector('.search-results-form-topic .search-results-form-topic-bare-id');
    let toggleButton = document.querySelector('.search-results-form-topic .enhanced-input-dropdown-btn');

    if (!input || !hiddenInput || !toggleButton) {
        return;
    }

    let topics = JSON.parse(input.dataset.topics);

    getSearchAutocompletion(input, toggleButton, Object.values(topics));

    if (hiddenInput.value && undefined !== topics[hiddenInput.value]) {
        input.value = topics[hiddenInput.value];
    }

    let updateHiddenInputFunc = () => {
        let item = Object.entries(topics).find(item => {
            return item[1] === input.value;
        });

        hiddenInput.value = item ? item[0] : '';
    };
    input.addEventListener('input', updateHiddenInputFunc);
    input.addEventListener('awesomplete-selectcomplete', updateHiddenInputFunc);
}

let googleMapsDeployed = false;
function deployGoogleMaps() {
    if (!window.app.googleMapsApiUrl) {
        return;
    }

    const googleMapsScriptSrc = document.createElement('script');
    googleMapsScriptSrc.setAttribute('src',window.app.googleMapsApiUrl);
    document.head.appendChild(googleMapsScriptSrc);
    googleMapsDeployed = true;
}

function setupCitySearchAutocompletion()
{
    let input = document.querySelector('.search-results-form-city .enhanced-input-control');
    let toggleButton = document.querySelector('.search-results-form-city .enhanced-input-dropdown-btn');

    if (!input || !toggleButton) {
        return;
    }

    let defaultCities = JSON.parse(input.dataset.cities);
    let autocompletion = getSearchAutocompletion(input, toggleButton, defaultCities);

    let googleAutocompleteService = null;
    let googleAutocompleteSettings = {
        types: ['(cities)'],
        componentRestrictions: { country: 'pl' },
    };

    autocompletion.filter = () => { return true; };
    autocompletion.sort = false;

    input.addEventListener('focus', () => {
        if (!googleMapsDeployed) {
            deployGoogleMaps();
        }
    });

    input.addEventListener('input', () => {
        if (!googleMapsDeployed) {
            deployGoogleMaps();
            return;
        }
        if (!googleAutocompleteService) {
            googleAutocompleteService = new google.maps.places.AutocompleteService();
        }
        let typedText = input.value;

        if (!typedText) {
            autocompletion.list = defaultCities;
            autocompletion.evaluate();

            return;
        }

        googleAutocompleteService.getPlacePredictions(
            { input: typedText, ...googleAutocompleteSettings },
            (predictions, status) => {
                autocompletion.list = [];

                if (status != google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                    autocompletion.list = predictions.map(prediction => {
                        return prediction.structured_formatting.main_text;
                    });
                }

                autocompletion.evaluate();
            }
        );
    });
}

function setupSearchFormWithCity()
{
    const routes = window.app.routes;

    let topicInput = document.querySelector('.search-results-form-topic .search-results-form-topic-bare-id');
    let cityInput = document.querySelector('.search-results-form-city .enhanced-input-control');
    let form = document.querySelector('.search-results-form');

    form.addEventListener('submit', event => {
        event.preventDefault();

        if (!cityInput.value) {
            return;
        }

        let url = routes.BASE_URL + '/' + routes.SEARCH_RESULTS_PREFIX + '/' + cityInput.value;

        if (topicInput && topicInput.value) {
            url += '?topic=' + topicInput.value;
        }

        window.location.href = url;
    });
}

function setupSearchFormOnline()
{
    const routes = window.app.routes;

    let topicInput = document.querySelector('.search-results-form-topic .search-results-form-topic-bare-id');
    let form = document.querySelector('.search-results-form');

    form.addEventListener('submit', event => {
        event.preventDefault();

        let url = routes.BASE_URL + '/' + routes.EXPERTS_ONLINE;

        if (topicInput && topicInput.value) {
            url += '?topic=' + topicInput.value;
        }

        window.location.href = url;
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const routes = window.app.routes;

    setupTopicSearchAutocompletion();
    setupCitySearchAutocompletion();

    let isSearchResultsPageWithCity = window.location.pathname.includes(routes.SEARCH_RESULTS_PREFIX);
    if (isSearchResultsPageWithCity) {
        setupSearchFormWithCity();
    }
    else {
        setupSearchFormOnline();
    }
});
